import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import CallApi from 'components/common/custom-components/CallApi';
import { getYYYYMMDDFormatDate, roundToTwoDecimals } from 'helpers/utils';
import useUrl from 'hooks/useUrl';
import React, { useEffect, useState } from 'react';
import { Row, Col, Card, ProgressBar } from 'react-bootstrap';

const SplitByMonth = ({ startDate, endDate, clientId }) => {
  const [data, setData] = useState([]);
  const [apiCallInProcess, setApiCallInProcess] = useState(false);

  useEffect(() => {
    loadlisting();
  }, [endDate, clientId]);

  const loadlisting = () => {
    if (startDate && endDate && clientId) {
      setApiCallInProcess(true);
      CallApi.get(
        `/avaza/client-overview/split-by-month?start_date=${getYYYYMMDDFormatDate(
          startDate
        )}&end_date=${getYYYYMMDDFormatDate(endDate)}&client_id=${clientId}`,
        false
      ).then(json => {
        if (json.status == 200) {
          setData(json.data);
          setApiCallInProcess(false);
        }
      });
    }
  };

  const columns = [
    {
      accessor: 'month',
      Header: 'Month'
    },
    {
      accessor: 'hours',
      Header: 'Hours',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => cell.value + ' h',
      footerProps: {
        className: 'text-end'
      },
      Footer: info => {
        const total = React.useMemo(
          () =>
            roundToTwoDecimals(
              info.page.reduce((sum, row) => row.values.hours + sum, 0)
            ),
          [info.page]
        );
        return total + ' h';
      }
    },
    {
      accessor: 'avaza_log',
      Header: 'Ads',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => cell.value + ' h',
      Footer: info => {
        const total = React.useMemo(
          () =>
            roundToTwoDecimals(
              info.page.reduce((sum, row) => row.values.avaza_log + sum, 0)
            ),
          [info.page]
        );
        return <div className="text-end">{total} h</div>;
      }
    },
    {
      accessor: 'status',
      Header: 'Status',
      headerProps: {
        className: 'text-center'
      },
      cellProps: {
        className: 'text-nowrap white-space-nowrap'
      },
      footerProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => (
        <ProgressBar>
          <ProgressBar
            now={cell.value}
            label={cell.value + ' %'}
            variant={cell.value <= 100 ? 'success' : 'danger'}
          />
        </ProgressBar>
      )
    },
    {
      accessor: 'diff',
      Header: 'Difference',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => (
        <div className={cell.value < 0 ? 'text-danger' : 'text-success'}>
          {cell.value} h
        </div>
      ),
      Footer: info => {
        const total = React.useMemo(
          () =>
            roundToTwoDecimals(
              info.page.reduce((sum, row) => row.values.diff + sum, 0)
            ),
          [info.page]
        );
        return <div className="text-end">{total} h</div>;
      }
    },
    {
      accessor: 'uppstart',
      Header: 'Uppstart',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => cell.value + ' h',
      Footer: info => {
        const total = React.useMemo(
          () =>
            roundToTwoDecimals(
              info.page.reduce((sum, row) => row.values.uppstart + sum, 0)
            ),
          [info.page]
        );
        return <div className="text-end">{total} h</div>;
      }
    },
    {
      accessor: 'avaza_lopande',
      Header: 'Löpande',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => cell.value + ' h',
      Footer: info => {
        const total = React.useMemo(
          () =>
            roundToTwoDecimals(
              info.page.reduce((sum, row) => row.values.avaza_lopande + sum, 0)
            ),
          [info.page]
        );
        return <div className="text-end">{total} h</div>;
      }
    },
    {
      accessor: 'seo',
      Header: 'SEO',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => cell.value + ' h',
      Footer: info => {
        const total = React.useMemo(
          () =>
            roundToTwoDecimals(
              info.page.reduce((sum, row) => row.values.seo + sum, 0)
            ),
          [info.page]
        );
        return <div className="text-end">{total} h</div>;
      }
    },
    {
      accessor: 'avaza_extra',
      Header: 'Extra',
      headerProps: {
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end'
      },
      sortType: 'basic',
      Cell: ({ cell }) => cell.value + ' h',
      Footer: info => {
        const total = React.useMemo(
          () =>
            roundToTwoDecimals(
              info.page.reduce((sum, row) => row.values.avaza_extra + sum, 0)
            ),
          [info.page]
        );
        return <div className="text-end">{total} h</div>;
      }
    }
  ];

  return (
    <Row>
      <Col>
        <Card>
          <Card.Body>
            <AdvanceTableWrapper
              columns={columns}
              data={data}
              sortable
              pagination
              useTableFooter={true}
            >
              <Row className="align-items-end g-2 row mb-3">
                <Col className="col-auto">
                  <h5>Split By Month</h5>
                </Col>
                <Col className="col"></Col>
                <Col className="col-auto">
                  <AdvanceTableSearchBox table />
                </Col>
              </Row>
              <AdvanceTable
                table
                headerClassName="bg-200 text-900 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                  striped: true,
                  className: 'fs--1 mb-0 overflow-hidden'
                }}
                apiCallInProcess={apiCallInProcess}
                tableFooterClassName="table-secondary"
              />
              <AdvanceTableFooter
                table
                className="mt-3 mx-3"
                rowCount={data.length}
                rowInfo
                navButtons
                rowsPerPageSelection
              />
            </AdvanceTableWrapper>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default SplitByMonth;
